import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Background from "../assets/splash-bg.jpg";
import './Donations.css';
import Footer from './Footer.tsx';

const Donations: React.FC = () => {
  const location = useLocation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  // Lock page scroll while modal is open
  useEffect(() => {
    const prev = document.body.style.overflow;
    if (isModalOpen) document.body.style.overflow = "hidden";
    else document.body.style.overflow = prev || "";
    return () => {
      document.body.style.overflow = prev || "";
    };
  }, [isModalOpen]);

  return (
    <div className="donations-container">
      {/* Hero */}
      <div className="donations-hero-section" style={{ backgroundImage: `url(${Background})` }}>
        <div className="donations-overlay" />
        <div className="donations-content">
          <div className="donations-title-section">
            <h2 className="donations-main-title">DONATIONS</h2>
          </div>
        </div>
      </div>

      {/* Main */}
      <div className="donations-main-section">
        <div className="donations-main-content">
          <div className="donations-info-section">
            <div className="donations-text-content">
              <h3 className="donations-subtitle">
                <strong>Voices of Virtue</strong> is looking for sponsorships and collecting donations.
                Support the first student led Islamic conference in Bryan College Station, TX.
              </h3>
              <p className="donations-description">
                For more information about our sponsorship tiers, please reference the table down below.
              </p>
              <div className="donations-gratitude">
                <em>Jazakum Allahu khairan for your time and consideration.</em>
              </div>
            </div>

            <div className="donations-form-section">
              <div className="donation-form">
                <h4 className="form-title">Make a Donation</h4>
                <div className="form-container">
                  <div className="form-wrapper">
                    <button
                      className="expand-btn"
                      onClick={openModal}
                      title="Expand form"
                      aria-label="Expand form"
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        aria-hidden="true"
                      >
                        <polyline points="15,3 21,3 21,9" />
                        <polyline points="9,21 3,21 3,15" />
                        <line x1="21" y1="3" x2="14" y2="10" />
                        <line x1="3" y1="21" x2="10" y2="14" />
                      </svg>
                    </button>
                    <iframe
                      src="https://donate.charitystack.com/c289a077-7101-4a27-8068-7d9c182c2dfe"
                      title="Voices of Virtue Donation Form"
                      className="donation-iframe"
                      loading="lazy"
                      allowFullScreen
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Sponsorship Tiers */}
      <div className="sponsorship-section">
        <div className="sponsorship-content">
          <h2 className="sponsorship-title">SPONSORSHIP TIERS</h2>

          <div className="sponsorship-table">
            <div className="table-header">
              <div className="header-tier">TIER</div>
              <div className="header-amount">AMOUNT</div>
              <div className="header-benefits">BENEFITS</div>
            </div>

            <div className="table-row title-sponsor">
              <div className="tier-name"><strong>Title Sponsor</strong></div>
              <div className="tier-amount">$2,000+</div>
              <div className="tier-benefits">
                <ul>
                  <li>• Recognized as the <strong>main sponsor</strong> of the conference</li>
                  <li>• Logo placement on <strong>event materials</strong></li>
                  <li>• Full page advertisement in <strong>program booklet</strong></li>
                  <li>• Dedicated <strong>social media post</strong></li>
                  <li>• Special acknowledgment during <strong>opening and closing sessions</strong> and a brief allotted talk</li>
                  <li>• <strong>5 VIP passes</strong> reserved seating</li>
                </ul>
              </div>
            </div>

            <div className="table-row gold-sponsor">
              <div className="tier-name"><strong>Gold Sponsor</strong></div>
              <div className="tier-amount">$1,000</div>
              <div className="tier-benefits">
                <ul>
                  <li>• <strong>Logo placement</strong> on event banners and website</li>
                  <li>• Mention in <strong>social media promotions</strong></li>
                  <li>• Half page advertisement in <strong>program booklet</strong></li>
                  <li>• Acknowledgment during the <strong>opening session</strong></li>
                  <li>• <strong>3 VIP passes</strong></li>
                </ul>
              </div>
            </div>

            <div className="table-row silver-sponsor">
              <div className="tier-name"><strong>Silver Sponsor</strong></div>
              <div className="tier-amount">$500</div>
              <div className="tier-benefits">
                <ul>
                  <li>• Logo on website and select event materials</li>
                  <li>• Mention in event <strong>social media promotions</strong></li>
                  <li>• <strong>2 VIP passes</strong></li>
                </ul>
              </div>
            </div>

            <div className="table-row bronze-sponsor">
              <div className="tier-name"><strong>Bronze Sponsor</strong></div>
              <div className="tier-amount">$100</div>
              <div className="tier-benefits">
                <ul>
                  <li>• Name listed on event website</li>
                  <li>• Mention in event <strong>social media promotions</strong></li>
                  <li>• <strong>1 VIP pass</strong></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div
          className="modal-overlay"
          role="dialog"
          aria-modal="true"
          onClick={closeModal}
          onKeyDown={(e) => e.key === "Escape" && closeModal()}
        >
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
            role="document"
          >
            <button
              className="modal-close-btn"
              onClick={closeModal}
              title="Close"
              aria-label="Close"
            >
              ✕
            </button>

            <iframe
              src="https://donate.charitystack.com/c289a077-7101-4a27-8068-7d9c182c2dfe"
              title="Voices of Virtue Donation Form - Expanded"
              className="modal-iframe"
              loading="lazy"
              allowFullScreen
            />
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default Donations;